module.exports = __webpack_public_path__ + "static/media/arrow-right.d839350c.svg";